import { Controller } from "@hotwired/stimulus";

class DownloadLinkController extends Controller {
  async download(event) {
    if (this.loading) {
      event.preventDefault();
      return;
    }

    if (
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey ||
      event.button !== 0
    ) {
      return;
    }

    event.preventDefault();
    this.loading = true;
    this.setBusyState(true);

    try {
      const response = await fetch(this.downloadUrl, {
        credentials: "same-origin",
      });

      if (response.redirected || this.htmlResponse(response)) {
        window.location.assign(response.url);
        return;
      }

      if (!response.ok) {
        throw new Error(`Download failed with status ${response.status}`);
      }

      const blob = await response.blob();
      this.triggerDownload(blob, this.filenameFrom(response));
    } catch (_error) {
      window.location.assign(this.downloadUrl);
    } finally {
      this.loading = false;
      this.setBusyState(false);
    }
  }

  get downloadUrl() {
    return this.urlValue || this.element.getAttribute("href");
  }

  htmlResponse(response) {
    const contentType = response.headers.get("Content-Type") || "";
    return contentType.includes("text/html");
  }

  filenameFrom(response) {
    const disposition = response.headers.get("Content-Disposition") || "";
    const utf8Match = disposition.match(/filename\*=UTF-8''([^;]+)/i);

    if (utf8Match) {
      return decodeURIComponent(utf8Match[1]);
    }

    const plainMatch = disposition.match(/filename="?([^";]+)"?/i);
    return plainMatch ? plainMatch[1] : "download";
  }

  triggerDownload(blob, filename) {
    const objectUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");

    link.href = objectUrl;
    link.download = filename;
    link.style.display = "none";

    document.body.appendChild(link);
    link.click();
    link.remove();

    window.setTimeout(() => {
      window.URL.revokeObjectURL(objectUrl);
    }, 0);
  }

  setBusyState(isBusy) {
    this.element.setAttribute("aria-busy", String(isBusy));
    this.element.setAttribute("aria-disabled", String(isBusy));
  }
}

DownloadLinkController.values = {
  url: String,
};

export default DownloadLinkController;
